import { User } from "functions/src/firestore";
import React from "react";

const UserContext = React.createContext<User | undefined>(undefined);

export default UserContext;
